// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b9dj","top":"styles_top__3BLP0"};